import React from 'react';
import { PredictiveModControlPanel } from '../components/PredictiveModControlPanel';

export const ControlPredictivoPage: React.FC = () => {
  return (
    <div className="control-predictivo-page">
      <PredictiveModControlPanel />
    </div>
  );
};
